import React from 'react';

import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import Dashboard from './screens/Dashboard';
import Graficos from './screens/Graficos';
import GraficosTme from './screens/Graficos/Tme';
import GraficosTma from './screens/Graficos/Tma';
import GraficosVag from './screens/Graficos/Vag';
import GraficosVau from './screens/Graficos/Vau';
import GraficosPausas from './screens/Graficos/Pausas';
import GraficosTudo from './screens/Graficos/Tudo';
import Perguntas from './screens/Graficos/Perguntas';
import Login from './screens/Login';
import Cadastro from './screens/Cadastro';
import ResetPassword from './screens/ResetPassword';
import Users from './screens/Users';

import SaasClients from './screens/SaasClients';
import SaasClientsCreate from './screens/SaasClients/SaasClientsCreate';
import SaasClientsUpdate from './screens/SaasClients/SaasClientsUpdate';

import Usuarios from './screens/Usuarios';
import UsuariosCreate from './screens/Usuarios/UsuariosCreate';
import UsuariosUpdate from './screens/Usuarios/UsuariosUpdate';

import Operadores from './screens/Operadores';
import OperadoresCreate from './screens/Operadores/OperadoresCreate';
import OperadoresUpdate from './screens/Operadores/OperadoresUpdate';

import Filas from './screens/Filas';
import FilasCreate from './screens/Filas/FilasCreate';
import FilasUpdate from './screens/Filas/FilasUpdate';

import Ura from './screens/Ura';
import UraCreate from './screens/Ura/UraCreate';
import UraUpdate from './screens/Ura/UraUpdate';

import Audios from './screens/Audios';
import AudiosCreate from './screens/Audios/AudiosCreate';
import AudiosUpdate from './screens/Audios/AudiosUpdate';

import Devices from './screens/Devices';
import DevicesCreate from './screens/Devices/DevicesCreate';
import DevicesUpdate from './screens/Devices/DevicesUpdate';

import Atendentes from './screens/Atendentes';
import AtendentesCreate from './screens/Atendentes/AtendentesCreate';
import AtendentesUpdate from './screens/Atendentes/AtendentesUpdate';

import Parceiros from './screens/Parceiros';
import ParceirosCreate from './screens/Parceiros/ParceirosCreate';
import ParceirosUpdate from './screens/Parceiros/ParceirosUpdate';

import Clientes from './screens/Clientes';
import ClientesImport from './screens/Clientes/ClientesImport';
import ClientesCreate from './screens/Clientes/ClientesCreate';
import ClientesUpdate from './screens/Clientes/ClientesUpdate';

import Servicos from './screens/Servicos';
import ServicosCreate from './screens/Servicos/ServicosCreate';
import ServicosUpdate from './screens/Servicos/ServicosUpdate';

import ConfiguracoesUpdate from './screens/Configuracoes/ConfiguracoesUpdate';
// import Pdf from './screens/Pdf';
import PerfilForm from './screens/Perfil/PerfilForm';

import AttendancePause from './screens/AttendancePause';
import AttendancePauseCreate from './screens/AttendancePause/AttendancePauseCreate';
import AttendancePauseUpdate from './screens/AttendancePause/AttendancePauseUpdate';

import RelatoriosLogin from './screens/Relatorios/Login';
import RelatoriosPausa from './screens/Relatorios/Pausa';
import RelatoriosPausaSintetica from './screens/Relatorios/PausaSintetica';
import Abandonadas from './screens/Relatorios/Abandonadas';
import AbandonadasAtendidas from './screens/Relatorios/AbandonadasAtendidas';
import Atendidas from './screens/Relatorios/Atendidas';
import Realizadas from './screens/Relatorios/Realizadas';
import Sintetico from './screens/Relatorios/Sintetico';
import ChamadasMapaAtendimento from './screens/Relatorios/ChamadasMapaAtendimento';
import RelatoriosTempoMedioEspera from './screens/Relatorios/TempoMedioEspera';
import GerenciaLogin from './screens/Gerencia/Login';
import GerenciaLoginUpdate from './screens/Gerencia/LoginUpdate';
import Delay from './screens/Gerencia/Delay';

import AtendidasV2 from './screens/Relatorios/AtendidasV2';
import AtendidasClientes from './screens/Relatorios/AtendidasClientes';

import { isAuthenticated } from './auth'


const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route 
    { ...rest } 
    render={props => (
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
      )
    )} />
)

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path="/login" component={Login} />
      <Route exact path="/cadastro" component={Cadastro} />

      <PrivateRoute exact path="/" component={PerfilForm} />
      <Route exact path="/graficos" component={Graficos} />
      <PrivateRoute exact path="/graficos/tme" component={GraficosTme} />
      <PrivateRoute exact path="/graficos/tma" component={GraficosTma} />
      <PrivateRoute exact path="/graficos/vag" component={GraficosVag} />
      <PrivateRoute exact path="/graficos/vau" component={GraficosVau} />
      <PrivateRoute exact path="/graficos/pausas" component={GraficosPausas} />
      <PrivateRoute exact path="/graficos/tudo" component={GraficosTudo} />
      <PrivateRoute exact path="/graficos/perguntas" component={Perguntas} />

      <PrivateRoute exact path="/perfil" component={PerfilForm} />

      <PrivateRoute exact path="/saas-client" component={SaasClients} />
      <PrivateRoute path="/saas-client/create" component={SaasClientsCreate} />
      <PrivateRoute path="/saas-client/update/:id" component={SaasClientsUpdate} />

      <PrivateRoute exact path="/operadores" component={Operadores} />
      <PrivateRoute path="/operadores/create" component={OperadoresCreate} />
      <PrivateRoute path="/operadores/update/:id" component={OperadoresUpdate} />

      <PrivateRoute exact path="/usuarios" component={Usuarios} />
      <PrivateRoute path="/usuarios/create" component={UsuariosCreate} />
      <PrivateRoute path="/usuarios/update/:id" component={UsuariosUpdate} />

      <PrivateRoute exact path="/devices" component={Devices} />
      <PrivateRoute path="/devices/create" component={DevicesCreate} />
      <PrivateRoute path="/devices/update/:id" component={DevicesUpdate} />

      {/* <PrivateRoute exact path="/usuarios" component={Atendentes} />
      <PrivateRoute path="/usuarios/create" component={AtendentesCreate} />
      <PrivateRoute path="/usuarios/update/:id" component={AtendentesUpdate} /> */}

      <PrivateRoute exact path="/atendentes" component={Atendentes} />
      <PrivateRoute path="/atendentes/create" component={AtendentesCreate} />
      <PrivateRoute path="/atendentes/update/:id" component={AtendentesUpdate} />
      
      <PrivateRoute exact path="/parceiros" component={Parceiros} />
      <PrivateRoute path="/parceiros/create" component={ParceirosCreate} />
      <PrivateRoute path="/parceiros/update/:id" component={ParceirosUpdate} />
      
      <PrivateRoute exact path="/clientes" component={Clientes} />
      <PrivateRoute path="/clientes/create" component={ClientesCreate} />
      <PrivateRoute path="/clientes/update/:id" component={ClientesUpdate} />
      <PrivateRoute exact path="/clientes/import" component={ClientesImport} />
      
      <PrivateRoute exact path="/servicos" component={Servicos} />
      <PrivateRoute path="/servicos/create" component={ServicosCreate} />
      <PrivateRoute path="/servicos/update/:id" component={ServicosUpdate} />
      
      <PrivateRoute exact path="/filas" component={Filas} />
      <PrivateRoute path="/filas/create" component={FilasCreate} />
      <PrivateRoute path="/filas/update/:id" component={FilasUpdate} />

      <PrivateRoute exact path="/ura" component={Ura} />
      <PrivateRoute path="/ura/create" component={UraCreate} />
      <PrivateRoute path="/ura/update/:id" component={UraUpdate} />

      <PrivateRoute exact path="/audios" component={Audios} />
      <PrivateRoute path="/audios/create" component={AudiosCreate} />
      <PrivateRoute path="/audios/update/:id" component={AudiosUpdate} />

      <PrivateRoute exact path="/attendance-pause" component={AttendancePause} />
      <PrivateRoute path="/attendance-pause/create" component={AttendancePauseCreate} />
      <PrivateRoute path="/attendance-pause/update/:id" component={AttendancePauseUpdate} />
      
      <PrivateRoute exact path="/relatorios/login" component={RelatoriosLogin} />
      <PrivateRoute exact path="/relatorios/pausa" component={RelatoriosPausa} />
      <PrivateRoute exact path="/relatorios/pausa-sintetica" component={RelatoriosPausaSintetica} />
      <PrivateRoute exact path="/relatorios/abandonadas" component={Abandonadas} />
      <PrivateRoute exact path="/relatorios/abandonadas-atendidas" component={AbandonadasAtendidas} />
      <PrivateRoute exact path="/relatorios/atendidas" component={AtendidasV2} />
      <PrivateRoute exact path="/relatorios/atendidas-clientes" component={AtendidasClientes} />
      <PrivateRoute exact path="/relatorios/realizadas" component={Realizadas} />
      <PrivateRoute exact path="/relatorios/sintetico" component={Sintetico} />
      <PrivateRoute exact path="/relatorios/chamadas/mapa-atendimento" component={ChamadasMapaAtendimento} />

      <PrivateRoute exact path="/gerencia/logins" component={GerenciaLogin} />
      <PrivateRoute exact path="/gerencia/logins/update/:id" component={GerenciaLoginUpdate} />
      <PrivateRoute exact path="/gerencia/delay" component={Delay} />

      <PrivateRoute path="/configuracoes" component={ConfiguracoesUpdate} />
      {/* <PrivateRoute path="/pdf" component={Pdf} /> */}

      
      <PrivateRoute exact path="/recuperar-senha" component={ResetPassword} />

    </Switch>
  </BrowserRouter>
)

export default Routes;